import { useEffect } from "react";
import { useScreenContext } from "../Layout";
import { useTranslation } from "react-i18next";
import { useSessionStorage } from "react-use";
import { useSearchParams } from "react-router-dom";

const startImage: any = {
  br: require("../../assets/images/start.br.png"),
  en: require("../../assets/images/start.en.png"),
  es: require("../../assets/images/start.es.png"),
};

function Start() {
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const [screenData, setScreenData] = useScreenContext();
  const [getSessionStorageOffer, setSessionStorageOffer] = useSessionStorage(
    "offer",
    "foo"
  );

  useEffect(() => {
    if (searchParams.get("offer")) {
      setSessionStorageOffer(searchParams.get("offer") || "");
    } else {
      setSessionStorageOffer("");
    }

    setScreenData(() => ({
      ...screenData,
      submitLabel: t("layout.cta_continue", {
        interpolation: { escapeValue: false },
      }),
      nextPath: "age",
      progress: 7,
    }));
  }, []);

  return (
    <div>
      <h1 className="mb-4 mt-5 text-4xl font-bold tracking-tight text-gray-900 dark:text-white md:text-5xl lg:text-6xl">
        {t("start.headline")}
      </h1>
      <p
        className="text-md mb-0 px-7 py-4 font-normal text-gray-900 lg:text-xl"
        dangerouslySetInnerHTML={{
          __html: t("start.subheadline", {
            interpolation: { escapeValue: false },
          }),
        }}
      ></p>
      <div className="container">
        <img
          className="mx-auto"
          width="300"
          alt="Woman with a list of books"
          src={startImage[i18n.language]}
        />
      </div>
    </div>
  );
}

export default Start;
